// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__2iUg8","title":"AfterImages45_title__1sQpx","images":"AfterImages45_images__UDHV5"};